export const JPMC = "JPMC";
export const JPMC_AIS = "JPMC_AIS";
export const MICRODEPOSITS = "MICRODEPOSITS";
